import script from "./dropdown-item.vue?vue&type=script&setup=true&lang=js"
export * from "./dropdown-item.vue?vue&type=script&setup=true&lang=js"

import "./dropdown-item.vue?vue&type=style&index=0&id=2fed9c9d&scoped=true&lang=css"

import exportComponent from "/home/ubuntu/ciyc-web-frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2fed9c9d"]])

export default __exports__